import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Breadcrumbs, Link, Typography } from '@mui/material';
import { harmonateTokens as ht } from '../../../theme/harmonateTokens';
import { MDH_HUB_PATH } from './merchantDataHubNav';

/**
 * Breadcrumb trail back to Merchant Data Hub (for Credit Card Reports / Chargebacks).
 */
const MerchantDataHubBreadcrumb = ({ currentLabel, propertyLabel }) => {
  const navigate = useNavigate();

  const currentSx = {
    color: ht.white,
    fontSize: '0.75rem',
    fontWeight: 700,
  };
  const linkSx = {
    cursor: 'pointer',
    color: ht.white,
    fontSize: '0.75rem',
    '&:hover': { color: ht.white, opacity: 0.85 },
  };

  let pageLabel = currentLabel;
  if (propertyLabel) {
    pageLabel = `${currentLabel} — ${propertyLabel}`;
  }

  return (
    <Box sx={{ mb: 1.5, flexShrink: 0 }}>
      <Breadcrumbs
        aria-label="breadcrumb"
        sx={{
          fontSize: '0.75rem',
          '& .MuiBreadcrumbs-separator': { color: ht.white },
        }}
      >
        <Link underline="hover" color="inherit" onClick={() => navigate(MDH_HUB_PATH)} sx={linkSx}>
          Merchant Data Hub
        </Link>
        <Typography color="text.primary" sx={currentSx}>
          {pageLabel}
        </Typography>
      </Breadcrumbs>
    </Box>
  );
};

export default MerchantDataHubBreadcrumb;
